import { getBoApiBasePath } from 'apps/core/utils/services';
import { GET } from 'service/REST';

export const authCheck = (initCheck: boolean): Promise<Response> =>
  GET(getBoApiBasePath('/metadata'), undefined, initCheck);

export const logout = (): Promise<Response> =>
  // returns a 302 redirect to auth.iqservices i.e. the login page via keycloak
  GET('/paymentiq/logout');
